import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { SET_TOKEN } from "../../../redux/userAuth";
import { verify2FA } from "../../../redux/settings";
import RazorModal from "../../../components/razor-reuse/modal/RazorModal";
import RazorInputField from "../../../components/razor-reuse/inputField/RazorInputField";

export default function LoginMFAOtp({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) {
  const pinRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state.auth);
  const { loading_mfa } = useSelector((state: RootState) => state.settings);
  const [completeToken, setCompleteToken] = useState<boolean>(false);
  const [details, setDetails] = useState({
    otp: "",
  });

  const verifyOtpFunc = async () => {
    const payload = {
      obj: {
        secret: details.otp,
      },
      tk: token,
    };
    const data = await dispatch(verify2FA(payload) as any);

    if (data?.payload?.data?.status) {
      localStorage.setItem("token", String(token));
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
      dispatch(SET_TOKEN(""));
    } else {
      setDetails((prev) => {
        return { ...prev, otp: "" };
      });
      setCompleteToken(false);
      //@ts-ignore
      pinRef?.current?.forEach((input: any) => (input.value = ""));
      //@ts-ignore
      pinRef?.current?.[0]?.focus();
    }
  };

  useEffect(() => {
    if (details.otp.length === 6) {
      verifyOtpFunc();
    }
  }, [details.otp]);

  return (
    <RazorModal
      outerClose={false}
      dontShowClose
      visible={visible}
      onClose={() => {}}
      onBtnClick={() => {}}
    >
      <div className="disabled-mfa-modal-wrap disabled-mfa-modal-wrap-padding">
        {/* title start */}
        <h4 className="header">2FA Authentication</h4>
        <p className="desc">Enter your code to access your account</p>
        {/* title end */}
        <div className="input-form-wrap">
          <RazorInputField
            pinRef={pinRef as any}
            color="black-light"
            type="pin"
            pinFieldNumber={6}
            value={details?.otp}
            onChange={(param: any) => {
              setDetails((prev) => {
                return { ...prev, otp: param };
              });
              setCompleteToken(false);
            }}
            onComplete={() => {
              setCompleteToken(true);
            }}
            // key={otpKey as any}
          />
        </div>
        <RazorInputField
          color={`black-light`}
          value="Proceed"
          type="submit"
          onSubmit={verifyOtpFunc}
          className="btn"
          disabled={!completeToken || loading_mfa}
          loading={loading_mfa}
        />
      </div>
    </RazorModal>
  );
}
